import { Icon as Icons } from '@material-ui/core'
import styled from 'styled-components'

import { colors } from '../../../../shared/styles/colors'

export const Container = styled.div`
  display: flex;
  height: 100vh;
  background: ${colors.dashboard};
  flex-direction: column;
`

export const Body = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  overflow-y: hidden;
`

export const BreadCrumb = styled.div`
  display: flex;
  width: 100%;
  height: 71px;
  flex-direction: row;
  align-items: center;
  padding: 30px;
  justify-content: flex-start;
  background-color: ${colors.white};
  z-index: 97;
`

export const Title = styled.div`
  font-family: 'Roboto';
  font-style: italic;
  font-size: 16px;
  font-weight: 700;
  color: ${colors.grayDark};
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`

export const ContainerCards = styled.div`
  width: 100%;
  height: 100%;
  padding: 20px 20px 20px 20px;
  overflow-y: scroll;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 6px;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${colors.blue};
    border-radius: 70px;
  }
`
export const Detalhes = styled.div`
  padding-left: 30px;
  padding-top: 30px;
  background-color: ${colors.white};
  border: 0px;
  border-radius: 8px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
`
export const TitleArea = styled.div`
  padding-bottom: 20px;
  color: ${colors.green};
  font-weight: bold;
`
export const Icon = styled(Icons)`
  color: ${colors.blue};
  display: flex;
  align-items: center;
`

export const Circle = styled.div`
  border: 1px solid black;
  border-radius: 50%;
`

export const IconSVG = styled.img`
  width: 120px;
  height: 120px;

  margin: 30px;

  @media (max-width: 1377px) {
    width: 100px;
    height: 100px;
  }
`
